/**
 * IB Web Common: Progress Indicator
 */


const progressBegin = 500;
const progressDuration = 20000;


function progressNode(el) {

    let progress;
    let children = el.childNodes;
    let i = children.length;
    while (i--) {
        if (children[i].classList && children[i].classList.contains('progress')) {
            progress = children[i];
            break;
        }
    }
    if (!progress) {
        progress = document.createElement('div');
        progress.className = 'progress';
        progress.appendChild(document.createElement('div'));
        el.appendChild(progress);
    }
    return progress;
}


export const progressStart = (el, beginTime=progressBegin) => {

    if (!el) {
        el = document.body;
    } else if (el.$el) {
        el = el.$el;
    }

    if (!el.progressCount) {
        progressNode(el);
        el.progressStart = setTimeout(function() {
            clearTimeout(el.progressStart);
            el.progressStart = null;
            if (el != document.body) {
                document.body.classList.add('noprogress');
            }
            el.classList.add('progress-show');
            el.progressTimeout = setTimeout(function() {
                el.progressCount = 0;
                el.progressTimeout = null;
                document.body.classList.remove('noprogress');
                el.classList.remove('progress-show');
            }, progressDuration);
        }, beginTime);
        el.progressCount = 1;
    } else {
        clearTimeout(el.progressTimeout);
        el.progressTimeout = setTimeout(function() {
            el.progressCount = 0;
            el.progressTimeout = null;
            document.body.classList.remove('noprogress');
            el.classList.remove('progress-show');
        }, progressDuration);
        el.progressCount++;
    }
}


export const progressEnd = (el) => {

    if (!el) {
        el = document.body;
    } else if (el.$el) {
        el = el.$el;
    }

    if (el.progressCount) {
        if (!--el.progressCount) {
            if (el.progressStart) {
                clearTimeout(el.progressStart);
                el.progressStart = null;
            }
            if (el.progressTimeout) {
                clearTimeout(el.progressTimeout);
                el.progressTimeout = null;
            }
            document.body.classList.remove('noprogress');
            el.classList.remove('progress-show');
        }
    }
}

